import сases1 from '../../assets/img/case1.png';
import сases2 from '../../assets/img/case2.png';
import сases3 from '../../assets/img/case3.png';
import сases4 from '../../assets/img/case4.png';
import сases5 from '../../assets/img/case5.png';
import сases6 from '../../assets/img/case6.png';

export const CasesSlider = [
	{
		path: сases1,
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
	},
	{
		path: сases2,
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
	},
	{
		path: сases3,
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
	},
	{
		path: сases4,
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
	},
	{
		path: сases5,
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
	},
	{
		path: сases6,
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
	},
];
